<div class="flex flex-col items-center justify-center w-full container-h bg-landing">
    <div class="home-container flex flex-col items-center justify-center">
        <div>
            <div class="text-4xl font-bold mb-4 t-w">Your platform for vehicle software solutions</div>
        </div>
        <div>
            <div class="t-w text-xl text-center">OpenAuto – Vehicle Software Solutions , Smarter, Faster, Completely free!!!
            </div>
            <div class="t-w text-center">Unlock powerful ECU editing tools.
            </div>
            <div class="t-w text-center">OpenAuto is your all-in-one platform for modifying vehicle software quickly and safely.
            </div>
            <div class="t-w text-center">Whether you're removing DPF, AdBlue, DTCs, or working with AITune-modified files, our tool gives you the freedom and control you need.
            </div>
            <div class="t-w text-xl text-center mt-4">-100% Free to Use
            </div>
            <div class="t-w text-center">No fees. No subscriptions. Just register with your email and start using the platform right away.
            </div>
            <div class="t-w text-xl text-center mt-4">-Instant Access – No Approval Required
            </div>
            <div class="t-w text-center">Forget waiting for approval. Once you register, you're in — full access, no delays.
            </div>
            <div class="t-w text-xl text-center mt-4">-Built for Professionals
            </div>
            <div class="t-w text-center">OpenAuto is crafted for tuners and workshops who need reliable, efficient ECU software solutions that just work.
            </div>
            <div class="t-w text-xl text-center mt-4">-Start in Under 30 Seconds
            </div>
            <div class="t-w text-center">Register with your email to gain instant access — no waiting, no hassle. Begin modifying now.
            </div>

        </div>
        <div class="text-3xl t-w mt-8 mb-4">
            Which vehicle is your solution for?
        </div>
        <div class="flex justify-center p-6 w-full">
            <form class="w-full max-w-lg sm:max-w-xl md:max-w-2xl lg:max-w-7xl" [formGroup]="form">
                <div class="flex flex-col md:flex-row">
                    <mat-form-field class="flex-1 px-1">
                        <mat-label class="t-w">Brand</mat-label>
                        <mat-select formControlName="brandId" 
                                    [panelClass]="'brand-select-panel'"
                                    (openedChange)="onBrandSelectOpened($event)">
                            <mat-option *ngFor="let option of filteredBrandOptions" [value]="option.value">
                                {{ option.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="flex-1 px-1">
                        <mat-label class="t-w">ECU Brand</mat-label>
                        <mat-select formControlName="ecuProducerId" 
                                    (selectionChange)="ecuProducerChange($event)"
                                    [panelClass]="'ecu-producer-select-panel'"
                                    (openedChange)="onEcuProducerSelectOpened($event)">
                            <mat-option *ngFor="let option of filteredEcuProducerOptions" [value]="option.value">
                                {{ option.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="flex-1 px-1">
                        <mat-label class="t-w">ECU Model</mat-label>
                        <mat-select formControlName="ecuTypeId" 
                                    [panelClass]="'ecu-type-select-panel'"
                                    (openedChange)="onEcuTypeSelectOpened($event)">
                            <mat-option *ngFor="let option of filteredEcuTypeOptions" [value]="option.value">
                                {{ option.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="flex items-center justify-center mt-4">
                    <button
                        class="ml-4 text-2xl btn-landing"
                        mat-flat-button
                        type="button"
                        color="primary"
                        (click)="search()"
                        [disabled]="!form.valid || isLoadingSpinnerActive">
                        <mat-spinner *ngIf="isLoadingSpinnerActive"></mat-spinner>
                        Search
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
